import type { AgentFocus } from '@tunasong/agent-context'
import { features } from '@tunasong/redux'
import type { TunaThunkDispatch } from '@tunasong/redux'

interface OpenSidebarAgentWithFocusArgs {
  agentId: string
  focus: AgentFocus
  /** Optional draft to pre-fill the composer with. */
  draft?: string
}

/**
 * Open the agent sidebar focused on a specific agent, with anchor context
 * preset in the composer. Fired by the generic block-affordance discovery
 * hook (useBlockActions) when a user clicks an agent-contributed item.
 *
 * The pending state is one-shot: AgentChat reads it on mount-or-update,
 * dispatches `agentStream` with `focus`, then clears via the existing
 * pending-state flow.
 */
export const openSidebarAgentWithFocus =
  (args: OpenSidebarAgentWithFocusArgs) =>
  (dispatch: TunaThunkDispatch) => {
    dispatch(features.ui.actions.setSidebarActiveTool('Agents'))
    dispatch(features.ui.actions.setSidebarActiveAgentId(args.agentId))
    dispatch(features.ui.actions.setSidebarPendingFocus(args.focus))
    if (args.draft !== undefined && args.draft.length > 0) {
      dispatch(features.ui.actions.setSidebarPendingDraft(args.draft))
    }
  }
